export const eventConstants = {
  SHOW_LOGIN_MODAL: 'SHOW_LOGIN_MODAL'
};
